export default {
  // SuperAdmin - Profile APIs
  getAllEvents: {
    url: "/api/v2/event/list/super?event_status={event_status}&school_id={school_id}&year={year}&month={month}",
    method: "get",
  },
  getSingleEventById: {
    url: "/api/v2/event/{event_id}",
    method: "get",
  },
  createEventSuper: {
    url: "/api/v2/event/super",
    method: "post",
  },
  deleteEventSuper: {
    url: "/api/v2/event/{event_id}",
    method: "delete",
  },
  updateEventSuper: {
    url: "/api/v2/event/{event_id}",
    method: "put",
  },
  getAllAccessedSessions: {
    url: "/api/v2/session/accessed/{class_id}",
    method: "get",
  },
  getTodaysEvents: {
    url: "/api/v2/event/today/{school_id}",
    method: "get",
  },
  getMonthlyEvents: {
    url: "/api/v2/event/month/{section_id}",
    method: "get",
  },
};
